import React from 'react'
import PageLayout from '../components/templates/pageLayout/pageLayout'
import ContentChallenges from '../components/organisms/contentChallenges/contentChallenges'

const Retos = () => {
  return (
    <PageLayout>
      <ContentChallenges />
    </PageLayout>
  )
}

export default Retos